import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_PERFILES = 'ALL_PERFILES';
export const LOADING_ALL_PERFILES = 'LOADING_ALL_PERFILES';
export const ACTIVO_PERFILES = 'ACTIVO_PERFILES';
export const PARAMS_PERFILES = 'PARAMS_PERFILES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const perfilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PERFILES:
      return {
        ...state,
        all: action.payload.data.sort((a, b) =>
          a.nombre.localeCompare(b.nombre),
        ),
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_PERFILES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_PERFILES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_PERFILES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
